import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dce78b50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coefficient-config-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "超账龄次数"),
    /*#__PURE__*/_createElementVNode("th", null, "电商客户"),
    /*#__PURE__*/_createElementVNode("th", null, "线下客户"),
    /*#__PURE__*/_createElementVNode("th", { class: "rating-col" }, "授信等级"),
    /*#__PURE__*/_createElementVNode("th", null, "折扣")
  ])
], -1))
const _hoisted_3 = { class: "readonly-col" }
const _hoisted_4 = { class: "rating-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: row.creditRating || index
          }, [
            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.formatOverLimitTimes(row)), 1),
            _createElementVNode("td", null, [
              (!_ctx.isRatingD(row))
                ? (_openBlock(), _createBlock(_component_oio_input, {
                    key: 0,
                    value: row.ecommerceCoefficient,
                    "onUpdate:value": ($event: any) => ((row.ecommerceCoefficient) = $event),
                    placeholder: ""
                  }, null, 8, ["value", "onUpdate:value"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (!_ctx.isRatingD(row))
                ? (_openBlock(), _createBlock(_component_oio_input, {
                    key: 0,
                    value: row.offlineCoefficient,
                    "onUpdate:value": ($event: any) => ((row.offlineCoefficient) = $event),
                    placeholder: ""
                  }, null, 8, ["value", "onUpdate:value"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_4, _toDisplayString(row.creditRating), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_oio_input, {
                value: row.discount,
                "onUpdate:value": ($event: any) => ((row.discount) = $event),
                placeholder: ""
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}